import { h } from "./../../utils/createElement";
import { __assign, __extends } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { emptyFn } from '../../utils/helper';
import { MenuItemContext } from './context';
import { consumeTheme } from '../../utils/theme';
var Item = (function (_super) {
    __extends(Item, _super);
    function Item() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.domRef = React.createRef();
        _this.handleClick = function (e) {
            var clickHandler = _this.context.clickHandler;
            if (_this.props.disabled) {
                e.stopPropagation();
                return;
            }
            clickHandler(_this.props.id);
        };
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style = _b.style, children = _b.children, onMouseEnter = _b.onMouseEnter, disabled = _b.disabled;
            var classes = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-disabled"] = disabled,
                _a));
            var itemStyle = _this.context.itemStyle;
            return (h("li", { className: classes, style: __assign(__assign({}, itemStyle), style), onClick: _this.handleClick, ref: _this.domRef, onMouseEnter: onMouseEnter }, children));
        };
        return _this;
    }
    Item.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    Item.contextType = MenuItemContext;
    return Item;
}(React.Component));
export default Item;
Item.defaultProps = {
    prefixCls: 'dui-m-menu-item',
    id: '',
    onMouseEnter: emptyFn,
    disabled: false
};
Item.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    id: PropTypes.string,
    onMouseEnter: PropTypes.func,
    disabled: PropTypes.bool
};
